import { render, staticRenderFns } from "./ReporteCxC.vue?vue&type=template&id=295a5f94"
import script from "./ReporteCxC.vue?vue&type=script&lang=js"
export * from "./ReporteCxC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports